
<ng-template #inputContent>
  <ng-content></ng-content>
</ng-template>

<div [className]="'float-left w-100 ' + wrapperClass">
  <div  *ngIf="isPlatformBrowser" role="list" class="nav nav-pills d-flex flex-column flex-sm-row" cdkDropListGroup>
    <ng-container *ngFor="let c of chips.getChips(); let i = index">
      <ng-template #tipContent>
          <p class="text-left p-0 m-0" *ngFor="let tip of (tipText$ | async)">
          {{tip}}
        </p>
      </ng-template>
      <div role="listitem" class="nav-item mr-2 mb-1 d-flex flex-row"
           #t="ngbTooltip"
           triggers="manual"
           cdkDropList
           [cdkDropListData]="{ index: i }"
           cdkDropListOrientation="horizontal"
           (cdkDropListDropped)="onDrop($event)"
           [ngbTooltip]="tipContent"
           (mouseover)="showTooltip(t, i)"
           (mouseout)="t.close()">
        <a class="flex-sm-fill text-sm-center nav-link active bg-info"
           cdkDrag
           (cdkDragStarted)="onDrag(i)"
           href="#"
           [class.disabled]="!clickable || (editable && c.editMode) || dragged === i  "
           [class.chip-selected]="(editable && c.editMode) || dragged === i"
           (click)="chipsSelected($event, i);">
          <span>
            <i *ngIf="showIcons && !c.isNestedItem()" dsAuthorityConfidenceState [authorityValue]="c.item" class="far fa-circle" aria-hidden="true">&nbsp;</i>
            <ng-container *ngIf="showIcons && c.hasVisibleIcons()">
              <span *ngFor="let icon of c.icons; let l = last" class="chip-stacked-icons">
                <i [ngbTooltip]="tipContent"
                   placement="right"
                   triggers="manual"
                   #t="ngbTooltip"
                   class="{{icon.style}}"
                   [class.mr-1]="!l"
                   [class.mr-2]="l"
                   dsAuthorityConfidenceState
                   [authorityValue]="c.item[icon.metadata] || c.item"
                   [visibleWhenAuthorityEmpty]="icon.visibleWhenAuthorityEmpty"
                   [showTooltip]="false"
                   aria-hidden="true"
                   (mouseover)="showTooltip(t, i, icon.metadata)"
                   (mouseout)="t.close()"></i>
                <i *ngIf="hasWillBeGenerated(c, icon.metadata)"
                   dsAuthorityConfidenceState
                   [authorityValue]="c.item[icon.metadata] || c.item"
                   [visibleWhenAuthorityEmpty]="icon.visibleWhenAuthorityEmpty"
                   class="fas fa-plus fa-stack-1x chip-stacked-icon"></i>
                <i *ngIf="hasWillBeReferenced(c, icon.metadata)"
                   dsAuthorityConfidenceState
                   [authorityValue]="c.item[icon.metadata] || c.item"
                   [visibleWhenAuthorityEmpty]="icon.visibleWhenAuthorityEmpty"
                   class="fas fa-search fa-stack-1x chip-stacked-icon"></i>
              </span>

            </ng-container>
           <p class="d-table-cell">{{textTruncate(c.display)}}</p>
            <i *ngIf="editable" class="fas fa-times ml-2"
               (click)="removeChips($event, i)"
               [title]="'chips.remove' | translate"></i>
          </span>
        </a>
      </div>
    </ng-container>
    <div [class.chips-sort-ignore]="(isDragging | async)" class="flex-grow-1">
      <ng-container *ngTemplateOutlet="inputContent"></ng-container>
    </div>
  </div>

  <div *ngIf="!isPlatformBrowser" role="list" class="nav nav-pills d-flex flex-column flex-sm-row">
    <ng-container *ngFor="let c of chips.getChips(); let i = index">
      <ng-template #tipContent>
        <p class="text-left p-0 m-0" *ngFor="let tip of (tipText$ | async)">
          {{tip}}
        </p>
      </ng-template>

      <div role="listitem" class="nav-item mr-2 mb-1">
        <a class="flex-sm-fill text-sm-center nav-link active bg-info"
           href="javascript:void(0);">
          <span>
            <i *ngIf="showIcons && !c.isNestedItem()" dsAuthorityConfidenceState [authorityValue]="c.item" class="far fa-circle" aria-hidden="true"></i>
            <ng-container *ngIf="showIcons && c.hasVisibleIcons()">
              <span *ngFor="let icon of c.icons; let l = last" class="chip-stacked-icons">
                <i class="{{icon.style}}"
                   [class.mr-1]="!l"
                   [class.mr-2]="l"
                   dsAuthorityConfidenceState
                   [authorityValue]="c.item[icon.metadata] || c.item"
                   [visibleWhenAuthorityEmpty]="icon.visibleWhenAuthorityEmpty"
                   [showTooltip]="false"
                   aria-hidden="true"></i>
                <i *ngIf="hasWillBeGenerated(c, icon.metadata)"
                   dsAuthorityConfidenceState
                   [authorityValue]="c.item[icon.metadata] || c.item"
                   [visibleWhenAuthorityEmpty]="icon.visibleWhenAuthorityEmpty"
                   class="fas fa-plus fa-stack-1x chip-stacked-icon"></i>
                <i *ngIf="hasWillBeReferenced(c, icon.metadata)"
                   dsAuthorityConfidenceState
                   [authorityValue]="c.item[icon.metadata] || c.item"
                   [visibleWhenAuthorityEmpty]="icon.visibleWhenAuthorityEmpty"
                   class="fas fa-search fa-stack-1x chip-stacked-icon"></i>
              </span>

            </ng-container>
           <p class="d-table-cell">{{textTruncate(c.display)}}</p>
            <i *ngIf="editable" class="fas fa-times ml-2"
               (click)="removeChips($event, i)"
               [title]="'chips.remove' | translate"></i>
          </span>
        </a>
      </div>
    </ng-container>
    <div [class.chips-sort-ignore]="(isDragging | async)" class="flex-grow-1">
      <ng-container *ngTemplateOutlet="inputContent"></ng-container>
    </div>
  </div>
</div>
